import { NameValuePair } from './NameValuePair';

export enum SystemEntityTypes {
  connections = 1,
  postedQuestion = 2,
  postedResponse = 3,
  postedReaction = 4,
  user = 5,
  product = 6,
  subscription = 7,
}

export enum PaymentTypes {
  onceOff = 1,
  subscription = 2,
}

export enum PaymentStatus {
  pending,
  complete,
  cancelled,
  partial,
}

export enum MembershipTypes {
  basic = 1000,
  premium = 2000,
}

export enum BillingCycleTypes {
  none,
  weekly,
  monthly,
  biAnnually,
  annually,
}

export enum ContactOptionTypes {
  mobileNumber = 1,
  email = 2,
  instagram = 3,
  facebook = 4,
  linkedIn = 5,
}

export enum GenderTypes {
  male = 1,
  female = 2,
  other = 3,
}

export enum ConnectionStatus {
  joining = 1,
  open = 2,
  closed = 3,
  pendingApproval = 4,
}

export enum ConnectionTypes {
  single = 1,
  group = 2,
}

export enum Gender {
  male = 1,
  female = 2,
}

export enum UserStatusTypes {
  active = 1,
  inactive = 2,
  removed = 10,
}

export enum SideConnectionStatusTypes {
  pending = 1,
  accepted = 2,
  rejected = 3,
}

export enum FeatureTypes {
  multiple = 100,
  questions = 1001,
  extends = 2001,
  sideConnections = 3001,
  customQuestions = 4001,
  readReceipts = 5001,
  throwbacks = 6001,
}

export enum OtpProcessTypes {
  login = 1,
  register = 2,
}

export enum DiscoverTypes {
  location = 1,
  network = 2,
}

export enum GeoLocationTypes {
  general = 1,
  questionPosted = 2,
}

export enum DistanceMeasurementTypes {
  km = 1,
  mi = 2,
}

export enum DiscoverUserActionTypes {
  skip = 1,
  requestConnection = 2,
  acceptConnectionRequest = 3,
}

export enum MasterDataTypes {
  userProfileReasons = 1,
}

export enum NotificationTypes {
  newMessage = 100,
  newConnection = 200,
  detailsShared = 300,
  connectionExpiringSoon = 400,
}

export enum UserProfileVerificationStatusTypes {
  unverified = 1,
  pendingVerification = 2,
  verified = 3,
}
